<template>

    <div class="user">
  
      <!--添加商家-->
      <div class="common-level-rail">
        <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/activity/activity/add'">添加佣金记录</el-button>
      </div>
      
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.title" placeholder="请输入房源备注"></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-input v-model="formInline.mobile" placeholder="请输入用户手机号/昵称"></el-input>
          </el-form-item>


          <el-form-item label="选择类型">
            <el-select v-model="formInline.is_settled" placeholder="请选择">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="未结算" :value="0"></el-option>
              <el-option label="已结算" :value="1"></el-option>
              <el-option label="已取消" :value="2"></el-option>
             
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
              <el-table-column prop="text" label="返佣用户" width="150">
                <template slot-scope="scope">
                  <div>{{ scope.row.user.nickName }}</div>
                  <div>{{ scope.row.user.mobile }}</div>
               </template>

              </el-table-column>

              <el-table-column prop="log_type" label="类型" width="150"></el-table-column>
              <el-table-column prop="act_price" label="实际金额" ></el-table-column>
              <el-table-column prop="price" label="返佣金额" ></el-table-column>
           
              <el-table-column prop="remark" label="备注" width="150"></el-table-column>
              <el-table-column prop="is_settled" label="是否结算">
                <template slot-scope="scope">
                  <div v-if="scope.row.is_settled == 0">未结算</div>
                  <div v-if="scope.row.is_settled == 1">已结算</div>
               </template>


              </el-table-column>
              <el-table-column prop="settled_time" label="结算时间" ></el-table-column>
              <el-table-column prop="create_time" label="创建时间" ></el-table-column>
              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
  
                  <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button><br />
                  <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
             :page-size="pageSize" layout="total, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import activityApi from '@/api/activity.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {
          is_settled:-1,
        },
        status: ['未开始', '进行中', '已结束'],
      };
    },
    created() {
  
      /*获取列表*/
      this.getTableList();
    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
  
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        activityApi.log(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            console.log(self.tableData)
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {});
      },
  
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
  
      /* 房源详情 */
      detailClick(row){
        let id = row.id;
         this.$router.push({
          path: '/plus/activity/activity/detail',
          query: {
            id: id
          }
        });
      },
  
      /* 浏览记录 */
      browseClick(row){
        let id = row.id;
         this.$router.push({
          path: '/plus/activity/activity/browse',
          query: {
            id: id
          }
        });
      },
  
      /*添加房源*/
      addClick() {
        this.$router.push('/plus/activity/activity/log/add');
      },
  
      /*编辑房源*/
      editClick(row) {
        let id = row.id;
        this.$router.push({
          path: '/plus/activity/activity/log/edit',
          query: {
            id: id
          }
        });
      },
  
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            activityApi.delLog(
              {
                id: row.id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.onSubmit();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {});
          })
          .catch(() => {});
      },
      
    }
  };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/activity/activity/log.vue